module.exports = {
  'name': 'atan',
  'category': 'Trigonometry',
  'syntax': [
    'atan(x)'
  ],
  'description': 'Compute the inverse tangent of a value in radians.',
  'examples': [
    'atan(0.5)',
    'atan(tan(2.3))'
  ],
  'seealso': [
    'tan',
    'acos',
    'asin'
  ]
};



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/docs/function/trigonometry/atan.js
// module id = 1071
// module chunks = 0